export const resourceTitle = "Cadastro de Usuários";
export const resourceName = "Usuário";

export const resourceKey = "usuario/geral";

export const idKey = "id";

export const headers = [
  { label: "Selecionar", key: "checkbox", isVisible: true },
  { label: "Nome", key: "nome", isVisible: true, iconTag: true },
  { label: "Login", key: "login", isVisible: true },
  { label: "Data de Cadastro", key: "datacadastro", isVisible: true },
  { label: "E-mail", key: "email", isVisible: true },
  { label: "Telefone", key: "telefone", isVisible: true },
  {
    label: "Ativo",
    key: "ativo",
    isVisible: true,
  },
];
